import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { ChartsModule } from 'ng2-charts';
import { CampaignActionButtonsComponent } from './campaign-action-buttons/campaign-action-buttons.component';
import { CampaignMediaSummaryTableComponent } from './campaign-media-summary-table/campaign-media-summary-table.component';
import { ErrorInputComponent } from './error-input/error-input.component';
import { FileUploaderComponent } from './file-uploader/file-uploader.component';
import { HighlightsComponent } from './highlights/highlights.component';
import { PerformanceInsightsComponent } from './performance-insights/performance-insights.component';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { MainNavigationComponent } from './main-navigation/main-navigation.component';
import { MaterialModule } from './material.module';
import { MunicipalityFeesSummaryTableComponent } from './municipality-fees-summary-table/municipality-fees-summary-table.component';
import { StatisticsChartComponent } from './statistics-chart/statistics-chart.component';
import { TableDataFieldComponent } from './table-data-field/table-data-field.component';
import { WarningMessageModalComponent } from './warning-message-modal/warning-message-modal.component';
import { ChannelStatusColorCodingComponent } from './channel-status-color-coding/channel-status-color-coding.component';
import { AttentionModalComponent } from './attention-modal/attention-modal.component';
import { CampaignTotalPriceSummarySection } from './campaign-total-price-summary-section/campaign-total-price-summary-section.component';
import { ChannelSelectionFieldComponent } from './channel-selection-field/channel-selection-field.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        FontAwesomeModule,
        MaterialModule,
        MatTooltipModule,
        RxReactiveFormsModule,
        NgbModule,
        ChartsModule
    ],
    declarations: [
        ErrorInputComponent,
        PerformanceInsightsComponent,
        MainNavigationComponent,
        MainLayoutComponent,
        HighlightsComponent,
        FileUploaderComponent,
        TableDataFieldComponent,
        WarningMessageModalComponent,
        AttentionModalComponent,
        StatisticsChartComponent,
        ChannelSelectionFieldComponent,
        CampaignActionButtonsComponent,
        ChannelStatusColorCodingComponent,
        CampaignTotalPriceSummarySection,
        CampaignMediaSummaryTableComponent,
        MunicipalityFeesSummaryTableComponent
    ],
    exports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,
        FontAwesomeModule,
        MaterialModule,
        MatTooltipModule,
        RxReactiveFormsModule,
        ErrorInputComponent,
        MainNavigationComponent,
        TableDataFieldComponent,
        CampaignMediaSummaryTableComponent,
        CampaignTotalPriceSummarySection,
        ChannelSelectionFieldComponent,
        MunicipalityFeesSummaryTableComponent,
        ChannelStatusColorCodingComponent,
        CampaignActionButtonsComponent,
        WarningMessageModalComponent,
        MainLayoutComponent,
        HighlightsComponent,
        PerformanceInsightsComponent,
        FileUploaderComponent,
        NgbModule,
        ChartsModule,
        StatisticsChartComponent
    ],
    entryComponents: [],
    providers: []
})
export class SharedModule {}
